import { localStorage } from 'dibs-browser-storage';

import { getFavoritesNudgeDisplayedCount } from './getFavoritesNudgeDisplayedCount.ts';
import { wasFavoritesNudgeDisplayed } from './wasFavoritesNudgeDisplayed.ts';

import { FAVORITES_LOCAL_STORAGE_KEYS, MAX_FAVORITES_NUDGE_DISPLAY_COUNT } from '../constants.ts';

function canDisplayFavoritesNudge(): boolean {
    const hideFavoritesNudge = !!localStorage.getItem(
        FAVORITES_LOCAL_STORAGE_KEYS.FAVORITES_NUDGE_HIDE
    );

    if (hideFavoritesNudge || wasFavoritesNudgeDisplayed()) {
        return false;
    }

    const favoritesNudgeDisplayedCount = getFavoritesNudgeDisplayedCount();

    return favoritesNudgeDisplayedCount < MAX_FAVORITES_NUDGE_DISPLAY_COUNT;
}

export { canDisplayFavoritesNudge };
